import React from "react";

function SubGroup({ title, className, classNameSpan, children }) {
  return (
    <div
      className={`${className} relative flex flex-col gap-4 border border-gray-200 rounded-xl bg-white px-4 pt-4 pb-3.5 shadow-[0_1px_2px_rgba(0,0,0,0.04)]`}
    >
      <span
        className={`${classNameSpan} absolute -top-2.5 left-3.5 bg-white px-2 text-[11px] font-semibold uppercase tracking-wide text-gray-500`}
      >
        {title}
      </span>
      {children}
    </div>
  );
}

export default SubGroup;
